// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__6PDnj","arrowUp":"style_arrowUp__rHEdA","arrowDown":"style_arrowDown__nKTA9","arrowStraight":"style_arrowStraight__YZ9Al"};